import { isNativeApp } from './platformUtils';

/**
 * Opens a URL in the device's default system browser (Safari/Chrome)
 * when running inside Capacitor, or in a new tab on regular web.
 *
 * Uses @capacitor/inappbrowser's openInExternalBrowser API which
 * reliably opens the OS default browser (not an in-app overlay).
 */
export const openExternal = async (url: string): Promise<void> => {
  if (isNativeApp()) {
    try {
      const { InAppBrowser } = await import('@capacitor/inappbrowser');
      await InAppBrowser.openInExternalBrowser({ url });
    } catch (e) {
      // Fallback: navigate away (will leave the WebView, but at least not blank)
      console.warn('[openExternal] InAppBrowser failed, falling back:', e);
      window.location.href = url;
    }
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
